import script from "./ExpoForTicket.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpoForTicket.vue?vue&type=script&setup=true&lang=js"

import "./ExpoForTicket.vue?vue&type=style&index=0&id=dc3e1224&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc3e1224"]])

export default __exports__